export default {"src":"/_next/static/media/background_refonte.fad59eed.svg","height":949,"width":708,"blurWidth":0,"blurHeight":0};